//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------


import { Injectable } from "@angular/core";
//import { ResponseContentType, Response } from "@angular/http";
import { Observable } from 'rxjs';
import { BasApiService } from '../base.api.service';
import {GridApiService} from './grid.api.service';
import * as ApiTypes from "../../models";

@Injectable()
export class RegionProtezApiService extends GridApiService<ApiTypes.RegionProtezViewModel,ApiTypes.RegionProtezViewFilterModels>{
  
  constructor(public baseService: BasApiService) {
   super(baseService);
    this.apiKey = "api/regionProtez";
  }
  
  delete = (regionId: number, protezId: number, currencyId: number): Observable<void> =>
    this.baseService.delete<void>(`api/RegionProtez/${regionId}/${protezId}/${currencyId}`, {}, true, true);   
  
  save = (model: ApiTypes.RegionProtezViewModel): Observable<void> =>
    this.baseService.post<void>(`api/RegionProtez`, model, {}, true, true);   
  
  getByReionIdCurrencyId = (regionId: number, currencyId: number): Observable<ApiTypes.RegionProtezViewModel[]> =>
    this.baseService.get<ApiTypes.RegionProtezViewModel[]>(`api/RegionProtez/getbyreionidcurrencyid/${regionId}/${currencyId}`, {}, true, true);   
  
  }

